export interface Article {
  slug: string;
  title: string;
  description: string;
  category: string;
  categoryName: string;
  content: string;
  tags: string[];
  imageUrl: string;
  date: string;
  readTime: string;
  featured: boolean;
  author: string;
}

export const articles: Article[] = [
  {
    slug: 'best-free-online-courses-asia',
    title: '2026年亚洲最值得收藏的免费在线课程平台大盘点',
    description: '精选来自中国、日本、韩国、印度等亚洲国家的优质免费在线学习资源，涵盖编程、语言、商业等多个领域，助你零成本提升技能。',
    category: 'online-learning',
    categoryName: '在线学习资源',
    content: `<p>在数字化时代，在线学习已经成为获取知识的重要途径。亚洲各国拥有丰富的免费在线教育资源，本文将为您详细介绍2026年最值得收藏的免费在线课程平台。</p>
<h2>中国大陆优质免费学习平台</h2>
<p>中国大学MOOC（慕课）是由网易与高教社携手推出的在线教育平台，汇集了来自北京大学、清华大学等顶尖高校的优质课程资源。平台提供超过8000门课程，涵盖计算机科学、经济管理、语言学习、人文社科等多个领域，全部免费开放学习。</p>
<p>学堂在线是清华大学发起的首个中文大规模开放在线课堂平台，与全球知名高校合作，提供超过5000门高质量课程。平台特色在于其与高校学分的对接机制，部分课程可获得官方认证证书。</p>
<p>Bilibili知识区近年来异军突起，聚集了大量优质的知识分享创作者。从编程教程到摄影后期，从数学物理到历史哲学，各类知识内容应有尽有，且完全免费。</p>
<h2>日本优质在线学习资源</h2>
<p>JMOOC（日本大规模开放在线课程）是日本版的MOOC平台，汇集了东京大学、京都大学等名校课程。平台提供日语和英语两种语言的学习体验，对于想要学习日本文化和技术的用户来说是非常宝贵的免费资源。</p>
<p>Schoo是日本知名的在线直播学习平台，每月提供超过600场免费直播课程。涵盖商业技能、IT技术、设计创意等热门领域，并支持录播回看功能。</p>
<h2>韩国在线教育平台推荐</h2>
<p>K-MOOC是韩国政府主导的免费在线教育平台，提供来自韩国顶尖大学的课程资源。平台在人工智能、半导体技术等韩国优势领域有丰富的课程内容。</p>
<h2>印度及其他亚洲国家资源</h2>
<p>NPTEL（印度国家技术增强学习计划）是由印度IIT和IISc联合推出的免费工程与科学课程平台，在计算机科学、电子工程等领域拥有世界级的内容质量。</p>
<p>此外，Coursera、edX等国际平台也有大量来自亚洲高校的免费旁听课程，是拓展国际视野的绝佳选择。</p>
<h2>如何高效利用免费学习资源</h2>
<p>建议制定明确的学习计划，每周固定时间投入学习。善用笔记工具记录重点，积极参与课程讨论区互动，结伴学习更能保持动力。记住，免费不等于低质量，关键在于坚持和实践。</p>`,
    tags: ['在线学习', '免费课程', 'MOOC', '教育平台', '技能提升'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Modern%20online%20learning%20environment%20with%20laptop%20displaying%20educational%20content%2C%20warm%20lighting%2C%20organized%20study%20desk%20with%20notebooks%20and%20plants%2C%20clean%20minimalist%20aesthetic%2C%20Asian%20student%20atmosphere%2C%20editorial%20photography%2C%20soft%20natural%20light&width=640&height=360&seq=article-courses-01&orientation=landscape',
    date: '2026-08-10',
    readTime: '8分钟',
    featured: true,
    author: '亚洲免费在线编辑团队',
  },
  {
    slug: 'free-design-tools-2026',
    title: '2026年设计师必备的10款免费在线设计工具',
    description: '从图形设计到UI设计，从图片编辑到动效制作，这里有设计师需要的全部免费在线工具，无需安装即开即用。',
    category: 'design-tools',
    categoryName: '设计工具资源',
    content: `<p>对于设计师而言，拥有得心应手的工具是提升工作效率的关键。近年来，在线设计工具的迅猛发展让设计师无需安装沉重的软件，打开浏览器即可开始创作。本文精选10款2026年最值得使用的免费在线设计工具。</p>
<h2>图形设计与矢量编辑</h2>
<p><strong>Canva</strong>是全球最受欢迎的在线设计平台之一，提供海量模板和素材库，即使没有设计基础的用户也能快速制作出精美的海报、社交媒体图片和演示文稿。免费版功能已经非常强大，是每个内容创作者的必备工具。</p>
<p><strong>Figma</strong>是UI/UX设计师的首选工具，基于浏览器的协作式设计平台让团队可以实时协作。免费版支持无限项目和文件，个人设计师完全可以满足日常需求。其强大的组件系统和插件生态让设计效率大幅提升。</p>
<p><strong>Penpot</strong>是一款开源的在线设计工具，支持矢量设计和原型制作。作为Figma的开源替代品，Penpot完全免费且无任何功能限制，特别适合注重数据隐私的设计团队。</p>
<h2>图片编辑与处理</h2>
<p><strong>Photopea</strong>被誉为"在线版Photoshop"，界面和操作逻辑与Photoshop高度相似，支持PSD、Sketch、XD等多种文件格式，功能强大到令人惊叹。对于偶尔需要处理设计文件的用户来说，Photopea是完美的免费选择。</p>
<p><strong>Remove.bg</strong>专注于一键去除图片背景，AI算法精准快速，处理效果令人满意。免费版每月可处理50张图片，对于日常使用完全够用。</p>
<h2>配色与字体工具</h2>
<p><strong>Coolors</strong>是最好用的在线配色方案生成器之一，按空格键即可随机生成配色，支持多种色彩模型，还能从图片中提取配色。设计师的配色灵感源泉。</p>
<p><strong>Google Fonts</strong>提供超过1500款免费开源字体，支持中文、日文、韩文等多语言字体。所有字体均可免费商用，是网页和UI设计的首选字体资源库。</p>`,
    tags: ['设计工具', '在线设计', 'UI设计', '免费工具', '设计师资源'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Creative%20designer%20workspace%20with%20colorful%20pantone%20swatches%20and%20sketches%2C%20minimalist%20desk%20setup%20with%20graphic%20tablet%2C%20warm%20lighting%2C%20modern%20Asian%20studio%20aesthetic%2C%20editorial%20photography%2C%20clean%20composition&width=640&height=360&seq=article-design-01&orientation=landscape',
    date: '2026-08-08',
    readTime: '6分钟',
    featured: true,
    author: '亚洲免费在线编辑团队',
  },
  {
    slug: 'free-dev-tools-collection',
    title: '程序员必备：亚洲最全免费在线开发工具合集',
    description: '整理亚洲开发者最爱的免费在线开发工具，包含代码编辑器、API测试、数据库管理、在线IDE等，大幅提升开发效率。',
    category: 'dev-tools',
    categoryName: '开发工具资源',
    content: `<p>无论是前端开发、后端开发还是全栈工程师，合适的开发工具都能让工作效率翻倍。本文整理了亚洲开发者社区中最受欢迎的免费在线开发工具，涵盖日常开发的各个方面。</p>
<h2>在线代码编辑器与IDE</h2>
<p><strong>GitHub Codespaces</strong>提供完整的云端开发环境，免费用户每月享有60小时的使用额度。基于VS Code的体验让你在任何设备上都能拥有完整的开发环境，特别适合多设备切换工作的开发者。</p>
<p><strong>CodeSandbox</strong>是最受欢迎的在线前端开发环境之一，支持React、Vue、Angular等主流框架的即时创建和预览。免费版功能丰富，是前端开发者的轻量级利器。</p>
<p><strong>StackBlitz</strong>基于WebContainers技术，在浏览器中运行完整的Node.js环境，速度惊人。支持Next.js、Nuxt等框架，是进行快速原型开发的绝佳选择。</p>
<h2>API开发与测试工具</h2>
<p><strong>Hoppscotch</strong>（原Postwoman）是一款轻量级的开源API请求构建工具，功能类似Postman但完全免费且无需注册。支持REST、GraphQL、WebSocket等多种协议。</p>
<p><strong>Swagger Editor</strong>是编写和预览OpenAPI规范的在线工具，支持实时语法检查，是API文档编写的好帮手。</p>
<h2>数据库管理工具</h2>
<p><strong>Supabase</strong>提供免费的开源Firebase替代方案，包含PostgreSQL数据库、认证、实时订阅、存储等完整功能。免费版提供500MB数据库空间，适合个人项目和小型应用。</p>
<p><strong>PlanetScale</strong>是基于MySQL的无服务器数据库平台，提供免费方案。其独特的数据库分支功能让schema变更变得安全可控。</p>
<h2>代码托管与协作</h2>
<p><strong>GitHub</strong>无需多言，全球最大的代码托管平台，免费版提供无限私有仓库。GitHub Actions的CI/CD功能让自动化构建部署触手可及。</p>
<p><strong>Gitee</strong>（码云）是中国最大的代码托管平台，在国内访问速度快，且针对中国开发者提供了丰富的中文文档和社区支持。</p>`,
    tags: ['开发工具', '编程资源', '在线IDE', '免费开发', '程序员工具'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Developer%20coding%20setup%20with%20dark%20theme%20code%20editor%20on%20screen%2C%20mechanical%20keyboard%20and%20coffee%2C%20minimalist%20desk%2C%20warm%20ambient%20lighting%2C%20modern%20tech%20workspace%2C%20editorial%20photography%2C%20clean%20Asian%20aesthetic&width=640&height=360&seq=article-dev-01&orientation=landscape',
    date: '2026-08-06',
    readTime: '7分钟',
    featured: true,
    author: '亚洲免费在线编辑团队',
  },
  {
    slug: 'free-ai-tools-asia-2026',
    title: '震撼发布：2026年亚洲免费AI工具完全指南',
    description: '人工智能正在改变世界，本文汇总了亚洲地区可以免费使用的顶级AI工具，从内容创作到图像生成，全面覆盖。',
    category: 'ai-tools',
    categoryName: 'AI工具资源',
    content: `<p>2026年，人工智能技术继续以惊人的速度发展。亚洲各国涌现了大量优质的AI工具，其中许多提供免费使用方案。本文为您精选最值得尝试的免费AI工具。</p>
<h2>AI内容创作工具</h2>
<p><strong>通义千问</strong>是阿里巴巴推出的免费AI大模型，支持中英文对话、文档分析、代码编写等功能。免费版使用额度充足，完全可以满足日常需求。</p>
<p><strong>文心一言</strong>是百度研发的知识增强大语言模型，在中文理解和生成方面表现出色。免费使用，支持多轮对话和创意写作。</p>
<p><strong>讯飞星火</strong>依托科大讯飞在语音技术上的积累，在语音识别和合成方面具有独特优势。免费版支持多种实用功能。</p>
<p><strong>Kimi</strong>（月之暗面）以超长上下文处理能力著称，单次可处理20万字内容，对于需要分析长篇文档的用户尤为实用。</p>
<h2>AI图像生成工具</h2>
<p><strong>通义万相</strong>是阿里推出的AI图像生成工具，支持文字生成图片、图片风格转换等功能。每日提供免费生成额度，中文理解精准。</p>
<p><strong>堆友</strong>专注于AI设计素材生成，可快速生成Logo、海报、插画等设计素材，免费方案能满足基本使用。</p>
<h2>AI办公效率工具</h2>
<p><strong>通义听悟</strong>是免费的AI音视频转文字工具，支持实时转写和多语言翻译，是会议记录和学习的得力助手。</p>
<p><strong>秘塔AI搜索</strong>是新一代AI搜索引擎，能直接给出结构化的搜索结果而非简单的链接列表，大幅提升信息获取效率。</p>
<h2>使用AI工具的建议</h2>
<p>AI工具虽然强大，但仍需人类判断力。建议将AI视为高效助手而非替代品，对AI产出内容保持审慎态度，结合自身专业知识进行判断和优化。</p>`,
    tags: ['AI工具', '人工智能', '免费AI', '智能工具', '内容创作'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Futuristic%20AI%20visualization%20with%20glowing%20neural%20network%20patterns%20on%20dark%20background%2C%20abstract%20digital%20brain%20concept%2C%20warm%20amber%20and%20gold%20accents%2C%20modern%20tech%20aesthetic%2C%20clean%20minimalist%20composition%2C%20high%20detail&width=640&height=360&seq=article-ai-01&orientation=landscape',
    date: '2026-08-04',
    readTime: '7分钟',
    featured: false,
    author: '亚洲免费在线编辑团队',
  },
  {
    slug: 'free-stock-images-resources-asia',
    title: '免费商用图片素材网站全攻略：亚洲设计师都在用',
    description: '整理最佳免费图片、插画、矢量图标素材网站，全部支持商用，设计师和内容创作者不可错过的资源合集。',
    category: 'stock-images',
    categoryName: '图片素材资源',
    content: `<p>高质量的视觉素材是优秀设计的基础，但专业图库的订阅费用往往不菲。幸运的是，互联网上有大量高质量的免费图片素材网站，其中不少支持免费商用。本文为您精选最优质的免费图片素材资源。</p>
<h2>免费高质量摄影图片</h2>
<p><strong>Unsplash</strong>是全球最大的免费高清摄影图片社区，拥有超过300万张精美图片，全部可免费商用。亚洲摄影师贡献了大量具有东方美学的优质作品，是寻找亚洲风格图片的首选。</p>
<p><strong>Pexels</strong>同样提供海量免费摄影作品和视频素材，每日更新，质量优秀。中文搜索支持良好，查找亚洲生活场景类图片效果出众。</p>
<p><strong>Pixabay</strong>不仅提供照片，还有大量插画、矢量图和视频素材，总量超过420万。所有内容均在Creative Commons CC0协议下发布，可自由使用无需署名。</p>
<h2>亚洲本土图片资源平台</h2>
<p><strong>泼辣有图</strong>是中国高质量的免费图库平台，聚焦中国本土题材图片。摄影师社区贡献了大量中国城市、自然风光和人文生活类图片。</p>
<p><strong>PAKUTASO</strong>是日本知名的免费素材网站，提供大量日系风格的摄影作品。图片风格清新自然，特别适合亚洲审美需求的设计项目。</p>
<h2>免费插画与矢量素材</h2>
<p><strong>unDraw</strong>提供完全开源的精美插画，支持在线调整配色以匹配品牌风格。所有插画都采用统一的设计语言，视觉一致性极佳。</p>
<p><strong>Humaaans</strong>专注于人物插画素材，可以自由组合不同的头部、身体、姿势和场景，创建出独一无二的人物角色。非常适合网站和App的插图设计。</p>
<p><strong>Illustration Kit</strong>提供免费的高品质矢量插画套装，覆盖商务、教育、科技等多种场景主题。</p>`,
    tags: ['图片素材', '免费图片', '设计素材', '商用图片', '插画资源'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Artistic%20collection%20of%20photography%20prints%20and%20camera%20equipment%20on%20minimalist%20desk%2C%20warm%20natural%20lighting%2C%20creative%20flat%20lay%20composition%2C%20vintage%20camera%20and%20lens%2C%20soft%20earth%20tones%2C%20editorial%20photography%2C%20clean%20aesthetic&width=640&height=360&seq=article-img-01&orientation=landscape',
    date: '2026-08-02',
    readTime: '6分钟',
    featured: false,
    author: '亚洲免费在线编辑团队',
  },
  {
    slug: 'free-productivity-tools-workflow',
    title: '告别低效：10款免费在线工具重塑你的工作流程',
    description: '精选提升工作效率的免费在线工具，从项目管理到文档协作，从时间规划到知识管理，全面优化工作流程。',
    category: 'productivity',
    categoryName: '办公效率工具',
    content: `<p>在快节奏的工作环境中，高效的工具就是最好的生产力。本文推荐10款真正好用且免费的在线效率工具，帮助您告别低效工作方式。</p>
<h2>项目管理与团队协作</h2>
<p><strong>Notion</strong>是近年最炙手可热的全能型工作空间工具，集笔记、文档、数据库、项目管理于一体。免费版已足够个人和小组使用，灵活的模块化设计让工作流程随心定制。</p>
<p><strong>飞书</strong>由字节跳动推出，将即时通讯、文档协作、日程管理、视频会议整合在一个平台中。免费版功能强大，特别适合亚洲团队的工作习惯。</p>
<p><strong>钉钉</strong>是阿里巴巴旗下的企业协作平台，在中国市场拥有广泛用户基础。免费版已包含丰富的办公协同功能。</p>
<h2>文档与笔记工具</h2>
<p><strong>石墨文档</strong>是中国领先的在线协作文档工具，支持多人实时编辑，界面简洁优雅。特别适合中文办公场景的使用需求。</p>
<p><strong>语雀</strong>由蚂蚁集团出品，定位为专业的云端知识库。结构化文档编辑体验出色，是个人知识管理和团队文档沉淀的理想选择。</p>
<h2>时间管理与专注工具</h2>
<p><strong>番茄ToDo</strong>是基于番茄工作法的专注计时应用，结合待办清单功能，帮助用户高效管理时间。极简的设计风格让人爱不释手。</p>
<p><strong>TickTick</strong>是一款全平台的待办事项管理工具，功能全面且设计精美。免费版已包含智能识别日期、循环提醒等核心功能。</p>
<h2>在线文档转换与处理</h2>
<p><strong>Smallpdf</strong>提供全面的PDF处理功能，包括转换、合并、压缩、编辑等，免费版每日可处理2个文件。操作简单直观，无需安装任何软件。</p>`,
    tags: ['效率工具', '办公工具', '项目管理', '团队协作', '时间管理'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Clean%20organized%20workspace%20with%20minimalist%20desk%20accessories%2C%20notebook%20and%20plant%2C%20warm%20natural%20lighting%2C%20productive%20office%20atmosphere%2C%20Asian%20modern%20aesthetic%2C%20soft%20earth%20tones%2C%20editorial%20photography%2C%20calm%20composition&width=640&height=360&seq=article-prod-01&orientation=landscape',
    date: '2026-07-30',
    readTime: '6分钟',
    featured: false,
    author: '亚洲免费在线编辑团队',
  },
  {
    slug: 'free-entertainment-asia-platforms',
    title: '亚洲免费影视娱乐平台推荐：宅家也能看遍亚洲好片',
    description: '整理亚洲各国优质免费影视、动漫、综艺资源平台，包括中国大陆、日本、韩国等地的免费正版内容渠道。',
    category: 'entertainment',
    categoryName: '影视娱乐资源',
    content: `<p>亚洲影视娱乐产业蓬勃发展，优质内容层出不穷。很多人不知道的是，许多平台都有免费的正版内容可以观看。本文将为您整理亚洲各国值得关注的免费影视娱乐平台。</p>
<h2>中国大陆免费影视平台</h2>
<p><strong>Bilibili（哔哩哔哩）</strong>不仅是一个视频分享社区，更是亚洲最大的ACG（动画、漫画、游戏）内容平台。大量正版动漫、纪录片、影视内容免费观看，弹幕文化更增添了独特的观影体验。</p>
<p><strong>西瓜视频</strong>是字节跳动旗下的免费视频平台，提供丰富的电影、电视剧、综艺节目内容。平台通过广告模式支撑运营，用户可免费观看大量正版影视内容。</p>
<h2>日本免费动漫与影视资源</h2>
<p><strong>ABEMA</strong>是日本知名的免费网络电视台，提供24小时直播频道和点播内容。动漫频道和日剧频道内容优质，完全免费观看，是日语学习者和日剧爱好者的宝藏平台。</p>
<p><strong>GYAO!</strong>提供大量日本电视剧、综艺节目和动漫的点播服务，免费会员即可观看海量内容，是了解日本流行文化的绝佳窗口。</p>
<h2>韩国免费娱乐内容</h2>
<p><strong>KBS World TV</strong>的YouTube频道提供大量韩国电视剧、综艺节目的完整版英文字幕内容，免费观看。对于韩流爱好者来说是不可错过的官方内容渠道。</p>
<p><strong>Viki</strong>（Rakuten Viki）是专注于亚洲内容的全球流媒体平台，提供大量韩剧、中剧、日剧的免费观看选项（带广告），并有多语言字幕支持。</p>
<h2>免费观影小贴士</h2>
<p>各平台免费内容的更新频率和范围会有所变化，建议关注官方通知。使用合法平台观看正版内容，既是对创作者的尊重，也能享受更好的观影体验。</p>`,
    tags: ['影视资源', '免费影视', '动漫资源', '亚洲影视', '在线娱乐'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Cozy%20home%20theater%20setup%20with%20large%20screen%20displaying%20colorful%20anime%20scene%2C%20comfortable%20couch%20with%20blanket%2C%20warm%20ambient%20lighting%2C%20snacks%20on%20coffee%20table%2C%20Asian%20living%20room%20aesthetic%2C%20cinematic%20photography%2C%20cozy%20vibes&width=640&height=360&seq=article-ent-01&orientation=landscape',
    date: '2026-07-28',
    readTime: '5分钟',
    featured: false,
    author: '亚洲免费在线编辑团队',
  },
  {
    slug: 'free-music-audio-resources-asia',
    title: '免费背景音乐与音效资源大全：创作者的声音素材库',
    description: '为视频创作者、播客制作者整理的免费音乐和音效资源网站，全部免费商用，再也不愁找不到合适的背景音乐。',
    category: 'audio-music',
    categoryName: '音频音乐资源',
    content: `<p>对于视频创作者、播客主播和游戏开发者来说，合适的背景音乐和音效是提升作品品质的关键。然而版权音乐的授权费用常常令人望而却步。本文精选提供免费商用音乐和音效的优质平台。</p>
<h2>免费背景音乐平台</h2>
<p><strong>YouTube音频库</strong>是YouTube为创作者提供的免费音乐和音效资源库，拥有数千首高品质背景音乐和音效。所有内容均标注了使用条件，大部分可免费商用，是视频创作者的首选资源。</p>
<p><strong>FreePD</strong>汇集了大量公有领域和原创免费音乐作品，风格涵盖古典、电子、爵士、氛围音乐等。所有音乐均可免费下载使用，无需署名。</p>
<p><strong>DOVA-SYNDROME</strong>是日本知名的免费背景音乐网站，拥有超过15000首原创音乐作品。日系风格音乐丰富，特别适合动漫风格视频和游戏配乐。</p>
<h2>免费音效资源</h2>
<p><strong>Freesound</strong>是全球最大的免费音效社区，收录超过50万个音效文件。从自然环境音到城市交通声，从乐器音到电子音效，种类极为丰富。使用前需注意每段音效的授权协议。</p>
<p><strong>Zapsplat</strong>提供高品质的免费音效和背景音乐，注册免费账户即可下载。音效制作精良，分类清晰，是游戏开发者的常用资源库。</p>
<h2>亚洲特色音频平台</h2>
<p><strong>耳聆网</strong>是中国优质的音频分享平台，用户可上传和下载各种声音作品。平台上有很多中国特色的声音素材，如传统乐器、方言、地方戏曲等珍贵音频资源。</p>
<p><strong>小森平的免费下载音效</strong>是日本个人创作者维护的音效网站，提供大量日系风格的游戏音效和系统提示音，深受独立游戏开发者喜爱。</p>`,
    tags: ['背景音乐', '免费音效', '音乐素材', '视频配乐', '音频资源'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Professional%20studio%20headphones%20and%20audio%20equipment%20on%20minimalist%20desk%2C%20sound%20wave%20visualization%20on%20screen%2C%20warm%20mood%20lighting%2C%20music%20production%20setup%2C%20modern%20Asian%20studio%20aesthetic%2C%20editorial%20photography%2C%20clean%20composition&width=640&height=360&seq=article-audio-01&orientation=landscape',
    date: '2026-07-25',
    readTime: '5分钟',
    featured: false,
    author: '亚洲免费在线编辑团队',
  },
];

export const getArticlesByCategory = (categorySlug: string): Article[] => {
  return articles.filter((a) => a.category === categorySlug);
};

export const getFeaturedArticles = (): Article[] => {
  return articles.filter((a) => a.featured);
};

export const getArticleBySlug = (slug: string): Article | undefined => {
  return articles.find((a) => a.slug === slug);
};

export const getRelatedArticles = (slug: string, limit: number = 3): Article[] => {
  const article = getArticleBySlug(slug);
  if (!article) return [];
  return articles
    .filter((a) => a.slug !== slug && a.category === article.category)
    .slice(0, limit);
};